export const ANALYTIC_ID = "UA-185659622-1";

// // --- Stage --- //
// export const STRIPE_ID = {
//   premium_monthly: "price_1LUoLvAlY9R4Wa1pW57ogfAf",
//   premium_quarterly: "price_1LUoLvAlY9R4Wa1pvUCJUKq8",
//   premium_yearly: "price_1LUoLvAlY9R4Wa1p63xnrDzq",
//   pro_monthly: "price_1LUoNVAlY9R4Wa1pasDLUkbq",
//   pro_quarterly: "price_1LUoNVAlY9R4Wa1prrRYzPlY",
//   pro_yearly: "price_1LUoNVAlY9R4Wa1poNKXsdh0",
//   lite_monthly: "price_1LUoKeAlY9R4Wa1pKWnFH3Pt",
//   lite_quarterly: "price_1LUoKeAlY9R4Wa1pjHhKUvSz",
//   lite_yearly: "price_1LUoKeAlY9R4Wa1pzJ3t9LGo",
// };
// export const STRIPE_PUBLIC =
//   "pk_test_51HWbXkAlY9R4Wa1pNNTATqAnlvpeeXyJ9I85E1B0QYUsIUPs84z84uQM9pVzm7hesVq2w6KQTmxu3tIXoEf0adRl0043MvXJnW";
// export const PAYPAL_CLIENT_ID =
//   "AQ58lfbo34MvYYhVOxBiLjziBQvAnOO5bN4JUdj9nxjiOKGkDn_03xqacAC8DWEj2vxCUh_8RSm6X_Pp";
// export const PAYPAL_ID = {
//   lite_monthly: "P-72J29231CS4680612ML7BARA",
//   lite_quarterly: "P-5M205282KR506954EML7BBEI",
//   lite_yearly: "P-4GF757066W302213UMMHP3GI",
//   premium_monthly: "P-76B0268383535172GMCXR7HQ",
//   premium_quarterly: "P-76B0268383535172GMCXR7HQ",
//   premium_yearly: "P-76B0268383535172GMCXR7HQ",
//   pro_monthly: "P-74U918610A5719342MCXR7TY",
//   pro_quarterly: "P-72J29231CS4680612ML7BARA",
//   pro_yearly: "P-52E196148S466304WMCXR74Y",
// };
// export const host = " https://api-stage.cfdhero.com/api";
// export const ws = "wss://api-stage.cfdhero.com";
// export const klineUrl = "https://api-stage.cfdhero.com/api/klines";



//--- Live --- //
export const STRIPE_ID = {
  premium_monthly: "price_1OZWR0AlY9R4Wa1p0Qt6ScD1",
  //premium_quarterly: "price_1OZWR0AlY9R4Wa1pt6EXe3yw",
  premium_yearly: "price_1OZWR0AlY9R4Wa1pMXiTK30H",
  pro_monthly: "price_1OZWSGAlY9R4Wa1p8bRghPPk",
  //pro_quarterly: "price_1OZWSGAlY9R4Wa1p5btpLWAu",
  pro_yearly: "price_1OZWSGAlY9R4Wa1pxbPz2uli",
  lite_monthly: "price_1OZWOrAlY9R4Wa1pbQjV5dNY",
  //lite_quarterly: "price_1OZWOrAlY9R4Wa1pcMTzbbCt",
  lite_yearly: "price_1OZWOrAlY9R4Wa1pSoYYiWJW",
};

export const STRIPE_PUBLIC =
  "pk_live_51HWbXkAlY9R4Wa1pGcd1HUcYxePvFEvdo7kktBbLHVdzXzwdk6huL41PTb6KhV8ozYtEv4I95lWZ5yJ4U1u4AXDx00yKzkVoI2";
export const PAYPAL_CLIENT_ID =
  "Aej4A5zdJZPIlZYmDHFawL9TMZxQcLQ-3kqnNGdX-eZxiUZIrTYcClH9JDbXd5g5tf9ZhqpEaZWi9s_0";

export const PAYPAL_ID = {
  lite_monthly: "P-6P685918307570514MWT2QBI",
  //lite_quarterly: "P-83N969857P391443PMWT2Q5Q",
  lite_yearly: "P-0GS692159J126553RMWT2ROQ",
  premium_monthly: "P-6BX729242E431180KMWT2R4I",
  //premium_quarterly: "P-2FK47837AD954400MMWT2SPY",
  premium_yearly: "P-33Y377629C471904VMWT2S4I",
  pro_monthly: "P-3SX7587482656774GMWT2THQ",
  //pro_quarterly: "P-85P86215XK803325VMWT2TUA",
  pro_yearly: "P-8A5466280V3916131MWT2T7Y",
};
export const host = "https://api.forexhero.ai/api";

export const ws = "wss://api.forexhero.ai";
export const klineUrl = "https://api.forexhero.ai/api/klines";
